<template>
  <div id="tab1" class="tab-panel">
    <div class="row">
      <div class="col-md-12">
        <div class="login-form-1">
          <form id="login-form" class="text-left">
            <div class="main-login-form">
              <div class="login-group">
                <div class="form-group">
                  <input
                    autocomplete="off"
                    @input="keypress"
                    :value="email"
                    name="email"
                    type="text"
                    class="form-control"
                    id="lg_username"
                    placeholder="Username"
                  />
                </div>
                <div class="form-group">
                  <input
                    autocomplete="off"
                    @input="keypress"
                    @keyup.enter="authByEmail"
                    name="password"
                    type="password"
                    class="form-control"
                    id="lg_password"
                    placeholder="Password"
                  />
                </div>
                <div
                  class="form-group form-group-remember no-margin no-padding login-group-checkbox"
                >
                  <div class="theme-checkbox">
                    <input
                      @click="remember"
                      type="checkbox"
                      value="check-box"
                      id="check-box-1"
                      name="radio-btn"
                      :checked="emailRemember"
                    />
                    <label for="check-box-1">Запомнить</label>
                  </div>
                </div>
              </div>
              <button
                v-if="!loading"
                @click="authByEmail"
                type="button"
                class="login-button"
              >
                <i class="fa fa-chevron-right"></i>
              </button>
            </div>
            <div class="etc-login-form text-center text-main">
              <p @click="resetPassword" class="mar-top-15 no-margin-bottom">
                <a>Забыл пароль?</a>
              </p>
            </div>
          </form>
        </div>
        <!-- End of Main Form -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["loading", "emailRemember", "email"],
  methods: {
    authByEmail() {
      this.$emit("authByEmail");
    },
    keypress(ev) {
      this.$emit("handleInput", ev);
    },
    remember(ev) {
      this.$emit("remember", ev);
    },
    resetPassword() {
      this.$router.push({ name: "reset" });
    }
  }
};
</script>
